import React from 'react';

export function EmptyState({
  icon = '📭',
  title,
  description,
  action,
}: {
  icon?: string;
  title: string;
  description?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="text-5xl mb-4 select-none" aria-hidden="true">{icon}</div>
      <h3 className="text-base font-semibold text-[hsl(var(--content))] mb-1">{title}</h3>
      {description && <p className="text-sm text-[hsl(var(--content-subtle))] max-w-sm">{description}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}

export function ErrorState({
  message,
  onRetry,
}: {
  message?: string;
  onRetry?: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="text-5xl mb-4 select-none" aria-hidden="true">⚠️</div>
      <h3 className="text-base font-semibold text-[hsl(var(--content))] mb-1">Something went wrong</h3>
      {message && <p className="text-sm text-[hsl(var(--content-subtle))] max-w-sm">{message}</p>}
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-4 rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700 transition-colors"
        >
          Try again
        </button>
      )}
    </div>
  );
}
